import { useEffect } from "react";

const BASE_URL = "https://jetseat.it";

export function useSEO({ title, description, noindex = false, canonical, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content) => {
      if (content == null) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    if (description) setMeta("description", description);
    setMeta("robots", noindex ? "noindex,nofollow" : "index,follow");

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonicalEl ? canonicalEl.getAttribute("href") : null;
    if (canonical) {
      if (!canonicalEl) {
        canonicalEl = document.createElement("link");
        canonicalEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.setAttribute("href", canonical.startsWith("http") ? canonical : `${BASE_URL}${canonical}`);
    }

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-dynamic-seo", "true");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      if (script) script.remove();
      if (canonical && canonicalEl && prevCanonical) canonicalEl.setAttribute("href", prevCanonical);
    };
  }, [title, description, noindex, canonical, jsonLd]);
}

export const SEO_BASE_URL = BASE_URL;
